<template>
  <VirtualListGrid :items="items" :itemSize="itemSize" ref="list">
    <template slot="header">
      <div class="c-virtual-list__head">
        <div class="c-virtual-list__col check"></div>
        <ThSort
          v-model="temp.sort"
          name="keyword"
          orderby="asc"
          tag="div"
          type="string"
          class="c-virtual-list__col keyword"
        >
          キーワード ({{ total }})
        </ThSort>
        <ThSort
          v-model="temp.sort"
          name="title"
          orderby="asc"
          tag="div"
          type="string"
          class="c-virtual-list__col title"
        >
          ページタイトル
        </ThSort>
        <ThSort
          v-model="temp.sort"
          name="type"
          orderby="desc"
          tag="div"
          type="string"
          class="c-virtual-list__col task"
        >
          直近の施策
        </ThSort>
        <ThSort
          v-model="temp.sort"
          name="doneDate"
          orderby="desc"
          tag="div"
          type="date"
          class="c-virtual-list__col doneDate"
        >
          完了日
        </ThSort>
        <ThSort
          v-model="temp.sort"
          name="rankDiff"
          orderby="desc"
          tag="div"
          type="number"
          class="c-virtual-list__col rankDiff"
        >
          順位変動
        </ThSort>
        <ThSort
          v-model="temp.sort"
          name="doneTaskRank"
          orderby="desc"
          tag="div"
          type="rank"
          class="c-virtual-list__col doneRank"
        >
          施策時順位
          <template slot="tooltip">
            <Tooltip size="sm">
              直近の施策完了日の順位です。
            </Tooltip>
          </template>
        </ThSort>
        <ThSort
          v-model="temp.sort"
          name="currentRank"
          orderby="desc"
          tag="div"
          type="rank"
          class="c-virtual-list__col currentRank"
        >
          現在の順位
          <template slot="tooltip">
            <Tooltip size="sm">
              直近で取得したGSCデータでの順位を表示します。
            </Tooltip>
          </template>
        </ThSort>
        <ThSort
          v-model="temp.sort"
          name="clicks"
          orderby="desc"
          tag="div"
          type="number"
          class="c-virtual-list__col clicks"
        >
          流入数
        </ThSort>
        <ThSort
          v-model="temp.sort"
          name="searchVolumes"
          orderby="desc"
          tag="div"
          type="number"
          class="c-virtual-list__col searchVolume"
        >
          月間検索数
        </ThSort>
        <ThSort
          v-model="temp.sort"
          name="impressions"
          orderby="desc"
          tag="div"
          type="number"
          class="c-virtual-list__col impressions"
        >
          表示回数
        </ThSort>
        <ThSort
          v-model="temp.sort"
          name="ctr"
          orderby="desc"
          tag="div"
          type="number"
          class="c-virtual-list__col ctr"
        >
          クリック率
        </ThSort>
        <ThSort
          v-model="temp.sort"
          name="conversions"
          orderby="desc"
          tag="div"
          type="number"
          class="c-virtual-list__col cv"
        >
          貢献CV
        </ThSort>
      </div>
    </template>
    <template slot="before">
      <div v-if="isLoading" class="c-virtual-list__guide">
        <div class="c-virtual-list__col">
          <Loading variant="inline" />
        </div>
      </div>
      <div v-else-if="!usage.current" class="p-results-check-guide">
        <p class="p-results-check-guide__lead">
          キーワードが登録されていません。まずはキーワードを登録しましょう。
        </p>
        <ButtonRectangle
          iconLeft="plus"
          priority="high"
          size="large"
          @click="openModalAddKeyword"
        >
          キーワード登録
        </ButtonRectangle>
      </div>
      <div v-else-if="!items.length" class="p-results-check-guide">
        <p class="p-results-check-guide__lead">
          表示できるデータがありません。明日以降に再度アクセスしてください。
        </p>
        <ul class="p-results-check-guide__list">
          <li>
            完了しているタスクが一つもない場合は、タスクを完了させ、翌日以降にアクセスしてください。
          </li>
          <li>
            この状態が数日間続くときは、チャットにてお問い合わせください。
          </li>
        </ul>
        <div class="p-results-check-guide__buttons">
          <ButtonRectangle :to="{ name: 'taskList' }" priority="low-white"
            >タスクリストを確認</ButtonRectangle
          >
        </div>
      </div>
    </template>
    <template v-if="items.length" v-slot="{ item }">
      <ListItemActionResult
        :key="item.id"
        :checked="checked"
        :item="item"
        @check="updateChecked"
      />
    </template>
  </VirtualListGrid>
</template>

<script>
import ButtonRectangle from '@/components/ButtonRectangle';
import ListItemActionResult from '@/components/siteImportantKeywordGA4/ListItemActionResult';
import Loading from '@/components/Loading';
import ThSort from '@/components/ThSort';
import Tooltip from '@/components/TooltipPortal';
import VirtualListGrid from '@/components/VirtualListGrid';

export default {
  props: {
    checked: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    sort: {
      type: Object,
      required: true
    },
    usage: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    ButtonRectangle,
    ListItemActionResult,
    Loading,
    ThSort,
    Tooltip,
    VirtualListGrid
  },
  data() {
    return {
      itemSize: 40,
      temp: {
        sort: Object.assign({}, this.sort)
      }
    };
  },
  computed: {
    total() {
      return this.items.length;
    }
  },
  watch: {
    'temp.sort': {
      handler(value) {
        this.$emit('sort', value);
      },
      deep: true
    }
  },
  methods: {
    updateChecked(checked) {
      this.$emit('check', checked);
    },
    openModalAddKeyword() {
      this.$emit('openModalAddKeyword');
    }
  }
};
</script>
